export default __webpack_public_path__ + "static/media/i_error.8cd33fd4.svg";